/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useState } from 'react';

import { getUserLanguageCode } from 'js/lib/language';
import { languageTagToLocalName } from 'js/lib/languageLocalized';

import { MenuList } from '@coursera/cds-core';
import { useTracker } from '@coursera/event-pulse/react';

import TranslationMenuModal from 'bundles/composable-page-header/components/translation/TranslationMenuModal';

import _t from 'i18n!nls/composable-page-header';

const styles = {
  labelPrefix: css`
    &::after {
      content: ' ';
    }
  `,
};

type Props = {
  courseId?: string;
  enterpriseOrgId?: string;
  labelPrefix?: string;
};

const LanguageTranslationMenuItem = ({ courseId, enterpriseOrgId, labelPrefix }: Props) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const track = useTracker();
  const locale = getUserLanguageCode();

  if (!locale) return null;

  const displayLabelPrefix = labelPrefix ?? _t('Language:');

  const handleClick = () => {
    track('open_navigation_menu', {
      navigationType: 'language',
    });

    setIsModalOpen(true);
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      handleClick();
    }
  };

  return (
    <>
      <MenuList.Item role="menuitem" onClick={handleClick} onKeyDown={handleKeyDown}>
        <span css={styles.labelPrefix}>{displayLabelPrefix}</span>
        {languageTagToLocalName(locale)}
      </MenuList.Item>
      {isModalOpen && (
        <TranslationMenuModal
          open={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          courseId={courseId}
          enterpriseOrgId={enterpriseOrgId}
        />
      )}
    </>
  );
};

export default LanguageTranslationMenuItem;
